import casinoHeader from "./../../_asset/etc/zeustitlecasino.png"
import slotHeader from "./../../_asset/etc/zeustitleslot.png"

export default function GameTitleHeader({ type }: { type: 'casino' | 'slot' }) {
    return (
        <header className="game-title-header">
            <div>
                <img src={type == 'casino' ? casinoHeader : slotHeader} alt="" />
            </div>
        </header>
    )
}